import React from "react";
import { StyledTabButton } from "./helpers/GlobalStylesv5";
import { tokens } from "../../theme/tokens";
import { SubjectType } from "../../types/CaseTypes";

interface SubjectTypeToggleProps {
  value: SubjectType;
  onChange: (type: SubjectType) => void;
}

// Same fill as Submit and the subject pills (style guide: labelled control).
const activeSx = {
  "&.active": {
    backgroundColor: tokens.color.brand.primaryAction,
    borderColor: tokens.color.brand.primaryAction,
    color: tokens.color.brand.onPrimary,
  },
  "&.active:hover": {
    backgroundColor: tokens.color.brand.primaryActionHover,
    borderColor: tokens.color.brand.primaryActionHover,
  },
};

const SubjectTypeToggle: React.FC<SubjectTypeToggleProps> = ({
  value,
  onChange,
}) => (
  <div
    role="group"
    aria-label="Subject type"
    style={{ display: "flex", gap: tokens.space[1] }}
  >
    {(["person", "business"] as const).map((type) => (
      <StyledTabButton
        key={type}
        className={value === type ? "active" : ""}
        aria-pressed={value === type}
        onClick={() => value !== type && onChange(type)}
        sx={activeSx}
      >
        {type}
      </StyledTabButton>
    ))}
  </div>
);

export default SubjectTypeToggle;
